import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { getIngredientsLoaded } from 'store/storeValtio';
import * as mh from 'helpers/medicationHelpers';
import * as ih from 'helpers/ingredientHelpers';
import chevLeft from 'icons/chevron-left-24.png';
import { deleteIngredientInDb } from 'store/localDb';
import LoadingComponent from '../common/LoadingComponent';
import ConfirmModal from '../common/ConfirmModal';
import Header from 'components/navigation/Header';

export default function IngredientList(props) {
  const [popup, setPopup] = useState({
    show: false,
    confirm: 'Delete',
    medName: 'tempName',
    id: null,
  });
  const navigate = useNavigate();
  const params = useParams();
  const medId = params.id;
  console.log('IngredientList', medId);

  const ingredientsLoaded = getIngredientsLoaded();

  if (!ingredientsLoaded) return (<LoadingComponent/>);

  let ingredients = [];
  let med = null;
  if (medId) {
    // get ingredients for medId
    med = mh.lookupMed(medId);
    //console.log('med', med);
    ingredients = ih.getIngredientsForMedId(medId);
  } else {
    // show all ingredients
    ingredients = ih.getAllIngredientsUnique();
  }

  //console.log('ingredients', ingredients);

  function addIngredient() {
    console.log('addIngredient');
    navigate('/supAddIngredients/'+med.medicationId);
  }

  function deleteIngredient(i) {
    console.log('deleteIngredient', i);
    setPopup({ 
      show: true, 
      confirm: 'Delete',
      medName: i.name, 
      id: i.id 
    });
    //setIsOpen(true);
  };
  const handleDeleteTrue = () => {
    console.log('handleDeleteTrue', popup.id);
    handleDeleteIngredient(popup.id);
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    console.log('handleDeleteFalse');
    setPopup({ show: false, taken: null, id: null });
  };

  async function handleDeleteIngredient(id) {
    console.log('handleDeleteIngredient', id);
    await deleteIngredientInDb(id);
    //deleteIngredient(id);
    //console.log(medsHistory);
  }

  function editIngredient(id) {
    console.log('editIngredient', id);
    navigate(`/editIngredient/${id}` );
  }

  function ingredientInfo(id) {
    console.log('ingredientInfo', id);
    navigate(`/ingredientInfo/${id}` );
  }

  function exit() {
    navigate(-1);
  }

  function details(id) {
    navigate(`/ingredientDetails/${id}/${med.medicationId}`);
  }

  return (
    <div className='mcard'>
      <ConfirmModal
        open={popup.show} 
        confirmButton={popup.confirm}
        onConfirm={()=>handleDeleteTrue()}
        onCancel={()=>handleDeleteFalse()}
        title={popup.medName}
        content={popup.taken}
        />
        { med && 
        <div className='mcard-screen flex justify-between'>
          <div className='flex flex-row items-center'>
            <div className='hover:cursor-pointer' onClick={()=>exit()}>
              <img src={chevLeft} alt='' />
            </div>
            <div className='pl-4'>
              <div>Ingredients for</div>
              <div>{med.name}</div>
            </div>
          </div>
        </div>
        }
        { !med && 
          // <div>Ingredients</div>
          <Header title='Ingredients' add={null} />
        }
        {/* <img className='w-10 hover:cursor-pointer' src={addIcon} onClick={()=>addIngredient()} alt="Add Ingredient"/> */}
      {ingredients.length === 0 && med &&
      <div className='w-full flex flex-col justify-center'>
        <div className='text-center my-8'>
          You do not have any ingredients entered
          <br/>
          Use the link below to add an ingredient
        </div>
        <div className='w-full flex justify-center'>
        <button 
          className='bg-blue-200 w-4/12 p-4 rounded-md'
          onClick={()=>addIngredient()}
        >Add ingredient</button>
        </div>
      </div>
      }
      {ingredients.length === 0 && !med &&
      <div className='w-full flex flex-col justify-center'>
        <div className='text-center my-8'>
          You do not have any ingredients entered
          <br/>
          Enter ingredients under Medications - Details
        </div>
      </div>
      }
      {/* <div className='text-lg font-medium text-green-600 bg-gray-200 border rounded mb-2 p-2'>{dt}</div> */}
      <div id='scroll_area' className='lcard mt-1'>
        {ingredients.map((i,ix) => {
          const name = ih.formatDisplayName(i);
          const dose = ih.formatDosage(i);
          return (
            <div key={ix} className='mcard border-2 border-gray-200 bg-blue-200 mb-1'>
              { !med &&
              <div className='flex flex-row justify-between p-2'>
                <div className='flex flex-col'>
                  <div className='mcard-text'>{name} ({i.DsldId})</div>
                </div>
                <button
                onClick={() => ingredientInfo(i.DsldId)}
                className='rawBtn py-1 px-2 bg-blue-500 text-white'
                > 
                  Info
                </button>
              </div>
              } 
              { med &&
              <div className='flex flex-row justify-between p-2 hover:cursor-pointer' onClick={()=>details(i.id)}>
                <div className='flex flex-col w-8/12'>
                  <div className='mcard-text'>{name}</div>
                  <div className='text-base font-semibold'>{dose}</div>
                </div>
              </div>
              } 
            </div>
          );
        })}
      </div>
    </div>
  )
}
